<template>
    <div class="container">
        <div class="layout-content">
            <global-header
                :school="1"
                :title="'학교 방문예약'"
            />
            <div class="content">
                <div class="input-area">
                    <div class="input-area__label">
                        <legend class="col-form-label">
                            SMS로 발송된 인증번호를 입력해주세요.
                        </legend>
                    </div>
                    <div class="input-area__input">
                        <el-input class="h48" v-model="auth_code"/>
                    </div>
                </div>
                <div class="resend">
                    <button @click="handleResend">인증번호 재발송</button>
                </div>
                <div class="submit-btn">
                    <button @click="handleSubmit">인증하기</button>
                    <button @click="handleBack" class="white">이전으로</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import GlobalHeader from "@/components/common/GlobalHeader.vue";
import { store } from "@/store";
import { ERROR_TYPE } from "@/lib/type";
import api from "@/api";

export default {
    name: "ExternalSmsAuth",
    data: () => ({
        store,
        auth_code: null,
    }),
    components: { GlobalHeader },
    methods: {
        async handleSubmit() {

            if(!this.auth_code || this.auth_code.length !== 5) {
                this.$alert.danger({ message: '발송된 인증코드를 정확히 입력하세요.' });
                return;
            }

            try {
                let response = {};
                const data = {
                    phone: store.visitor.phone,
                    code: this.auth_code
                };
                response = await api.identifyCheck(data);

                if (response.result === "success") {
                    store.auth = {
                        token: response.token,
                        type: "EXT_USER"
                    };

                    this.$alert.success({ message: '인증되었습니다.' });
                    this.$router.replace({ path: `/schools/${store.school.id}/visit/apply` });
                } else {
                    throw new Error(response.code);
                }
            } catch (e) {
                this.handleErrorMessage(e);
            }
        },

        handleBack() {
            this.$router.back();
        },

        async handleResend() {
            try {
                const data = {
                    phone: store.visitor.phone
                };
                let response = await api.identifySend(data);

                if (response.result === "success") {
                    this.$alert.success({ message: "인증번호를 다시 발송했습니다." });
                } else {
                    throw new Error(response.code);
                }
            } catch (e) {
                this.handleErrorMessage(e);
            }
        },

        handleErrorMessage(error) {
            let result = null;

            if (typeof error === "object") {
                result = ERROR_TYPE[error.message];
            } else {
                result = ERROR_TYPE[error];
            }

            const message = !result ? "알 수 없는 오류 발생" : result;

            this.$alert.danger({ message });
        },
    },
    mounted() {
        // 학교정보 없으면 초기화면으로 보냄
        if(!store.school.id) {
            this.$router.replace({ path: `/schools/${this.$route.params.school}/visit` });
        }
    }
};
</script>

<style scoped lang="scss">

</style>